import React from 'react';

import { useSelector } from 'react-redux';

import Filter from './filter';
import FilterButton from 'components/search_sidebar/filter_button';
import { filterSchemas, hasFilters } from './helpers';

import type { Filters } from './types';

export default function CompsCustomFieldFilters() {
  const features: Record<string, boolean> = useSelector((state: any) => state.features);
  const filters: Filters = useSelector((state: any) => state.query.customFieldFilters) || {};
  const currentTab: string = useSelector((state: any) => state.ui.currentTab);
  const schemas = filterSchemas(useSelector((state: any) => state.customFieldSchemas), currentTab);

  if (!features.edgeCrm || !schemas.length) {
    return null;
  }

  return (
    <FilterButton
      filtersApplied={hasFilters(schemas, filters, currentTab)}
      label="Custom Fields"
    >
      {schemas.map(schema => (
        <Filter
          filter={filters[schema.slug]}
          key={schema.id}
          schema={schema}
        />
      ))}
    </FilterButton>
  );
}
